// Inline WhatsApp glyph — matches lucide-react stroke width so it visually
// aligns with the other footer/contact icons.
export default function WhatsAppIcon({ size = 16, className = "", strokeWidth = 1.6 }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            aria-hidden="true"
            focusable="false"
        >
            <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
            <path d="M8.5 9.5c.4 1.8 1.7 3.6 3.4 4.7.7.5 1.5.9 2.3 1 .7.1 1.5-.2 1.9-.7l.5-.7c.2-.3.1-.7-.2-.9l-1.5-1c-.3-.2-.7-.1-.9.1l-.4.5c-.9-.4-1.8-1-2.5-1.9l.4-.4c.2-.2.3-.6.1-.9L10.7 8c-.2-.3-.6-.4-.9-.2l-.7.5c-.5.4-.7 1-.6 1.6z" />
        </svg>
    );
}
